"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const S = __importStar(require("./BottomNavigation.styles"));
exports.default = (props) => {
    const { state, descriptors, navigation, isVisible = true } = props;
    const amount = () => (isVisible ? 0 : -85);
    const top = react_1.useRef(new react_native_1.Animated.Value(amount())).current;
    react_1.useEffect(() => {
        react_native_1.Animated.timing(top, {
            toValue: amount(),
            duration: 200,
            useNativeDriver: false,
        }).start();
    }, [isVisible]);
    return (react_1.default.createElement(react_native_1.Animated.View, { style: [{ bottom: top }] },
        react_1.default.createElement(S.BottomNavigation, { isVisible: isVisible }, state.routes.map((route, index) => {
            const { options, } = descriptors[route.key];
            const isFocused = state.index === index;
            const onPress = () => {
                const event = navigation.emit({
                    type: 'tabPress',
                    target: route.key,
                    canPreventDefault: true,
                });
                if (!isFocused && !event.defaultPrevented) {
                    navigation.navigate(route.name);
                }
            };
            const onLongPress = () => {
                navigation.emit({
                    type: 'tabLongPress',
                    target: route.key,
                });
            };
            return (react_1.default.createElement(S.Item, { key: route.key, testID: options.tabBarTestID, onPress: onPress, onLongPress: onLongPress, accessible: true, accessibilityLabel: options.tabBarAccessibilityLabel, accessibilityRole: "tab", accessibilityHint: options.tabBarAccessibilityHint, style: { flex: 1 }, isFocused: isFocused },
                react_1.default.createElement(react_native_1.View, null,
                    react_1.default.createElement(S.Icon, null, options.tabBarIcon &&
                        options.tabBarIcon({
                            focused: isFocused,
                            color: '',
                            size: 0,
                        })))));
        }))));
};
